/**
 *	(c) 2024 Приволжский Исследовательский Медицинский Университет
 *
 *	@file: VideoSlider.js
 *  @description: Этот файл является частью клиентской стороны проекта. src Относится к части, которая содержит компоненты - части страниц, допускающие многократное использование в разных частях. VideoSlider.js
 *	@author: Горбас Александр Петрович, Белов Михаил Александрович
 */
import React, { useEffect, useState } from 'react';
import VideoPlayer from './VideoPlayer';
import './VideoSlider.css';

const VideoSlider = ({ id, videos, descriptions, language, onSlideChanged }) => {
    const [currentIndex, setCurrentIndex] = useState(0);

    const handleNext = () => {
        const newIndex = (currentIndex + 1) % videos.length;
        setCurrentIndex(newIndex);
        onSlideChanged && onSlideChanged(newIndex);
    };

    const handlePrev = () => {
        const newIndex = (currentIndex - 1 + videos.length) % videos.length;
        setCurrentIndex(newIndex);
        onSlideChanged && onSlideChanged(newIndex);
    };

    if (!videos || videos.length === 0) return null;

    return (
        <div className="video-slider-container">
            <div className="video-slider">
                <VideoPlayer key={id + currentIndex} id={id} idx={currentIndex} category='rehabilitation' />
                
                {videos.length > 1 && (
                    <div className="slider-navigation">
                        <button 
                            className="nav-button prev-button" 
                            onClick={handlePrev}
                            aria-label="Previous video"
                        >
                            <img src='/videoplayer_icons/prev.svg' alt="Previous" />
                        </button>
                        <div className="slide-counter">
                            {currentIndex + 1} / {videos.length}
                        </div>
                        <button 
                            className="nav-button next-button" 
                            onClick={handleNext}
                            aria-label="Next video"
                        >
                        <img src='/videoplayer_icons/next.svg' alt="Next" />
                        </button>
                    </div>
                )}
                
                {descriptions?.[language]?.[currentIndex] && (
                    <div className="video-description">
                        {descriptions[language][currentIndex]}
                    </div>
                )}
            </div>
        </div>
    );
};

export default VideoSlider;